module.exports = __webpack_public_path__ + "img/Logo_TFC_Negro.547915bc.png";